import { Button, makeStyles } from '@material-ui/core'
import classNames from 'classnames'
import React from 'react'

export function OptionSwitcher({
    className,
    options,
    selected,
    onChange,
    disabled,
    disabledOptions,
    style,
    large
}) {
    const cls = useStyles(large)()

    return (
        <div className={classNames(className, cls.radioGroup)} style={style}>
            {disabled && <div className={cls.disabledOverlay} />}
            {Object.entries(options).map(([value, label]) => {
                if (!label) {
                    return null
                }

                const optionDisabled = disabled || disabledOptions?.[value]

                return (
                    <div key={value} className={cls.btnWrapper}>
                        <Button
                            className={classNames(cls.radio, {
                                [cls.radioChecked]: value === selected,
                                [cls.radioHover]: value !== selected
                            })}
                            onClick={() => onChange(value)}
                            disabled={optionDisabled}
                            disableTouchRipple
                        >
                            {label}
                        </Button>
                    </div>
                )
            })}
        </div>
    )
}

const useStyles = isLarge =>
    makeStyles(theme => ({
        radioGroup: {
            height: isLarge ? 56 : 32,
            position: 'relative',

            width: 'fit-content',

            display: 'flex',
            alignItems: 'center',

            background: '#EBEBEB',
            borderRadius: '7px',

            padding: '4px'
        },
        disabledOverlay: {
            display: 'block',
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            background: 'rgba(255, 255, 255, 0.65)'
        },
        radio: {
            height: '100%',

            display: 'flex',
            alignItems: 'center',

            fontSize: '12px',
            lineHeight: '24px',

            borderRadius: '3.5px',
            padding: '0 10px',

            '&:not(:last-child)': {
                marginRight: '4px'
            }
        },
        radioHover: {
            '&:hover': {
                background: '#C1C1C1'
            }
        },
        radioChecked: {
            background: '#FFFFFF',
            '&:hover': {
                background: '#FFFFFF'
            }
        },
        indicator: {
            color: theme.palette.secondary.main
        },
        btnWrapper: {
            height: '100%'
        }
    }))
